import { render, staticRenderFns } from "./registre-crp.html?vue&type=template&id=f74ca47a&scoped=true&external"
import script from "./registre-crp.js?vue&type=script&lang=js&external"
export * from "./registre-crp.js?vue&type=script&lang=js&external"
import style0 from "./registre-crp.scss?vue&type=style&index=0&id=f74ca47a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ca47a",
  null
  
)

export default component.exports